import { type RefObject, useLayoutEffect } from 'react';

/**
 * Writes an element's drawn height on the root element as a CSS variable, follows it as it
 * changes, and takes it back when the element goes — for fixed things that sit against a band
 * whose height enlarged text or a wrapping line can change.
 */
export const usePublishedHeight = (ref: RefObject<HTMLElement | null>, variable: string) => {
  useLayoutEffect(() => {
    const element = ref.current;
    if (element === null) {
      return;
    }

    const root = document.documentElement;
    const publish = () => {
      root.style.setProperty(variable, `${element.getBoundingClientRect().height}px`);
    };
    publish();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(publish);
    observer?.observe(element);

    return () => {
      observer?.disconnect();
      root.style.removeProperty(variable);
    };
  }, [ref, variable]);
};
